import React, { useState } from 'react';
import './Contact.css';

function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: 'General Inquiry',
    message: '',
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    alert('Message sent!');
  };

  return (
    <div className="contact-page">
      <div className="contact-container">
        {/* Title */}
        <header className="contact-header">
          <h1>Contact Us</h1>
          <p className="contact-subtitle">
            Have a question, feedback, or just want to say hi? We'd love to hear
            from you.
          </p>
        </header>

        {/* Form */}
        <form className="contact-form" onSubmit={handleSubmit}>
          <div className="contact-field">
            <label htmlFor="name">Name</label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
            />
          </div>

          <div className="contact-field">
            <label htmlFor="email">Email</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>

          <div className="contact-field">
            <label htmlFor="subject">Subject</label>
            <select
              id="subject"
              name="subject"
              value={formData.subject}
              onChange={handleChange}
            >
              <option>General Inquiry</option>
              <option>Bug Report</option>
              <option>Feature Request</option>
              <option>Billing</option>
              <option>Partnership</option>
            </select>
          </div>

          <div className="contact-field">
            <label htmlFor="message">Message</label>
            <textarea
              id="message"
              name="message"
              rows="6"
              value={formData.message}
              onChange={handleChange}
              required
            />
          </div>

          <button type="submit" className="contact-submit">
            Send Message
          </button>
        </form>

        {/* Alternative contact info */}
        <div className="contact-alt">
          <p>
            You can also email us directly at{' '}
            <a href="mailto:support@applyai.co">support@applyai.co</a>
          </p>
          <p className="contact-response-time">
            We typically respond within 24 hours.
          </p>
        </div>
      </div>
    </div>
  );
}

export default Contact;
